module.exports = __webpack_public_path__ + "img/contr-1Icon@2x_1.b62f2f97.svg";